import { ComponentType, SVGProps, memo } from "react";

import { ReactComponent as ReportRoomSummary } from "assets/svg/report-summary-room.svg";
import { ReactComponent as ReportEnergySummary } from "assets/svg/report-summary-energy.svg";
import { ReactComponent as ReportWaterSummary } from "assets/svg/report-summary-water.svg";
import { ReactComponent as ReportWaterLeakageSummary } from "assets/svg/report-summary-water-leakage.svg";

import { ReportSummaryInfo, ReportTimeRangeType } from "types/Reports";
import { REPORT_SENSOR_REGISTRY } from "constant/report";

import ReportSummaryCard from "./ReportSummaryCard";

type ReportSummaryProps = {
    summaryInfo: ReportSummaryInfo;
    timeRangeType: ReportTimeRangeType;

    isRoomLoading: boolean;
    isEnergyLoading: boolean;
    isWaterLoading: boolean;
    isWaterLeakageLoading: boolean;
};

const SUMMARY_CARDS_CONFIG = [
    {
        key: 'room' as const,
        title: 'Room Occupancy',
        unit: '',
        textHighlightClassName: REPORT_SENSOR_REGISTRY.room.colorClassName,
        Icon: ReportRoomSummary as ComponentType<SVGProps<SVGSVGElement>>,
    },
    {
        key: 'energy' as const,
        title: 'Energy Consumption',
        unit: REPORT_SENSOR_REGISTRY.energy.unit,
        textHighlightClassName: REPORT_SENSOR_REGISTRY.energy.colorClassName,
        Icon: ReportEnergySummary as ComponentType<SVGProps<SVGSVGElement>>,
    },
    {
        key: 'water' as const,
        title: 'Water Consumption',
        unit: REPORT_SENSOR_REGISTRY.water.unit,
        textHighlightClassName: REPORT_SENSOR_REGISTRY.water.colorClassName,
        Icon: ReportWaterSummary as ComponentType<SVGProps<SVGSVGElement>>,
    },
    {
        key: 'waterLeakage' as const,
        title: 'Water Leakage Detection Count',
        unit: '',
        textHighlightClassName: REPORT_SENSOR_REGISTRY.waterLeakage.colorClassName,
        Icon: ReportWaterLeakageSummary as ComponentType<SVGProps<SVGSVGElement>>,
    },
];

export default memo(function ReportSummary({
    summaryInfo,
    timeRangeType,

    isRoomLoading,
    isEnergyLoading,
    isWaterLoading,
    isWaterLeakageLoading,
}: Readonly<ReportSummaryProps>) {
    const isLoadingByType = {
        room: isRoomLoading,
        energy: isEnergyLoading,
        water: isWaterLoading,
        waterLeakage: isWaterLeakageLoading,
    };

    return (
        <section className="d-block w-100 report-main-section">
            <div className="d-flex w-100 justify-content-between">
                {SUMMARY_CARDS_CONFIG.map(({ key, title, unit, textHighlightClassName, Icon }) => (
                    <ReportSummaryCard
                        key={key}
                        title={title}
                        itemType={key}
                        isLoading={isLoadingByType[key]}
                        timeRangeType={timeRangeType}
                        textHighlightClassName={textHighlightClassName}
                        unit={unit}
                        icon={<Icon width="80px" height="80px" />}
                        item={{...summaryInfo[timeRangeType][key]}}
                    />
                ))}
            </div>
        </section>
    );
});
